import { Head, useForm } from "@inertiajs/react"
import { NativeNavbar } from "@ruby-native/react"

import type { FormEvent } from "react"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import AppLayout from "@/layouts/app-layout"
import { newRecipeImportPath, recipeImportsPath, recipesPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Recipes", href: recipesPath() },
  { title: "Import Recipe", href: newRecipeImportPath() },
]

export default function New() {
  const { data, setData, post, processing, errors } = useForm({ url: "" })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post(recipeImportsPath())
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <NativeNavbar title="Import Recipe" />
      <Head title="Import Recipe" />

      <div className="mx-auto max-w-xl p-4">
        <h1 className="mb-2 text-2xl tracking-tight">Import a Recipe</h1>
        <p className="text-muted-foreground mb-6">
          Paste a URL to a recipe page and we'll extract the ingredients and
          instructions for you.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid gap-2">
            <Label htmlFor="url">Recipe URL</Label>
            <Input
              id="url"
              type="url"
              value={data.url}
              onChange={(e) => setData("url", e.target.value)}
              placeholder="https://example.com/recipe/..."
              required
            />
            <InputError messages={errors.url} />
          </div>

          <Button type="submit" disabled={processing}>
            {processing ? "Importing..." : "Import Recipe"}
          </Button>
        </form>
      </div>
    </AppLayout>
  )
}
